export const PREFIX = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN_EXPIRES: 'token_expires',
  COOKIE: 'b2b-official-cookie-',
  SESSION: 'b2b-official-session-'
};
export const STATUS_CODE = {
  TOKEN_NULL: 41000,
  CHECK_TOKEN_FAIL: 41001,
  TOKEN_ERROR: 41002,
  NOT_REGISTER: 42003,
  OPEN_CODE: 1
};
export const SYSTEM_CONFIG = {
  CHANNEL_CODE: 'ths-web-lab',
  DEVICE_INFO: '{"osv":"os版本","dct":"设备唯一标识","clv":"客户端版本","pm":"手机型号"}',
  CAPTCHA_AUTH: 1,
  REGISTER_EMAIL_CODE: 2,
  LOGIN_EMAIL_CODE: 3
};
export const PRODUCT_ID = {
  SHOU_YE: 'shouye',
  JING_XUAN: {
    JING_XUAN_1: 'jingxuan-jingxuan'
  },
  SHOU_JI_OEM: {
    SHOU_YE: {
      SHOU_YE_2019: 'shouji-shouye-2019',
      SHOU_YE_2020: 'shouji-shouye-2020',
      SHOU_YE: 'shouji-shouye'
    },
    HANG_QING: {
      HANG_QING_SHOU_YE: 'shouji-hangqing',
      YUN_HANG_QING: 'shouji-hangqing-yunhangqing'
    },
    GU_GU_HANG_QING: {
      PU_TONG_GE_GU: 'shouji-gegu-F10',
      LEVEL_2_GE_GU: 'shouji-Level2-F10',
      PAN_HOU_JIAO_YI: 'shouji-panhou-F10',
      H5_HANGQING: 'shouji-hangqing-H5'
    },
    ZI_XUAN_GU: 'shouji-zixuangu',
    JIAO_YI: {
      JIAO_YI_SHOU_YE: 'shouji-jiaoyi-shouye',
      JIAO_YI_JI_CHU: 'shouji-jiaoyi-jichu',
      TIAO_JIAN_DAN: 'shouji-jiaoyi-tiaojiandan',
      MO_NI_CHAO_GU: 'shouji-jiaoyi-monichaogu',
      XIAO_GUI_TAI: 'shouji-jiaoyi-xiaoguitai'
    },
    ZHI_NENG_TOU_ZI_ZHU_LI: 'shouji-zhinengtouzizhuli',
    ZHI_NENG_SOU_SUO: 'shouji-zhinengsousuo'
  },
  PC_KE_HU_DUAN: {
    PC_TONG_YI_BAN: 'pc-tongyiban',
    PC_JIN_RONG_ZHONG_DUAN: 'pc-jinrongzhongduan',
    PC_YUAN_HANG_BAN: 'pc-yuanhangban',
    PC_MAC_BAN: 'pc-mac',
    PC_JI_GOU_BAN: 'pc-jigouban'
  },
  OPEN_AI: {
    SHU_JU_ZHONG_XIN: 'openai-shujuzhongxin',
    XUAN_ZHENG_GU: 'openai-xuanzhengu',
    XUAN_ZHENG_JI: 'openai-xuanzhenji',
    YU_QING: 'openai-yuqing',
    ZI_XUN: 'openai-zixun'
  },
  TOU_GU: {
    REN_GONG_TOU_GU: 'tougu-rengongtougu',
    ZENG_ZHI_FU_WU: {
      DUAN_XIAN_BAO: 'tougu-zengzhifuwu-duanxianbao',
      SAO_LEI_BAN: 'tougu-zengzhifuwu-saoleibao'
    },
    ZHI_NENG_TOU_GU: {
      CE_LUE_BAO: 'tougu-zhinengtougu-celuebao',
      DUAN_XIAN_BAO: 'tougu-zhinengtougu-duanxianbao',
      ZHI_NENG_DING_TOU: 'tougu-zhinengtougu-zhinengdingtou'
    }
  },
  YUN_YING_GONG_JU: {
    LI_CAI_SHANG_CHENG: 'yunying-licaishangcheng',
    JI_FENG_SHANG_CHENG: 'yunying-jifenshangcheng',
    ZENG_ZHI_FU_WU_SHANG_CHENG: 'yunying-zengzhifuwu',
    DI_SAN_FANG_JIE_RU: 'yunying-disanfangjieru',
    TONG_YI_REN_ZHENG: 'yunying-tongyirenzheng',
    RONG_QI_BU_SHU: 'yunying-rongqibushu',
    ZI_XUAN_GU_TONG_BU: 'yunying-zixuangutongbu',
    HUO_DONG_YUN_YING_PING_TAI: 'yunying-huodongyunyingpingtai'
  },
  YUAN_GONG_DUAN: {
    YUAN_GONG_PING_TAI: {
      MO_KUAI_1: 'yuangongduan-yuangongpingtai-xxx'
    }
  },
  DA_SHU_JU: {
    DA_SHU_JU: 'dashuju',
    ZHANG_HU_FEN_XI: 'dashuju-zhanghufenxi',
    ZHANG_HU_ZHEN_DUAN: 'dashuju-zhanghuzhenduan',
    XING_WEI_FEN_XI: 'dashuju-xingweifenxi',
    BIAO_QIAN_XI_TONG: 'dashuju-biaoqianxitong',
    ZHI_NENG_TUI_JIAN: 'dashuju-zhinengtuijian',
    BIAO_QIAN_YUN: 'dashuju-biaoqianyun'
  },
  ZHI_NENG_TOU_YAN: {
    ZHI_NENG_TOU_YAN: 'zhinengtouyan-zhinengtouyan',
    YAN_BAO_GUAN_LI: 'zhinengtouyan-yanbaoguanli'
  },
  REN_GONG_ZHI_NENG: {
    ZHI_NENG_WAI_HU: 'rengongzhineng-zhinengwaihu',
    ZHI_NENG_ZHI_JIAN: 'rengongzhineng-zhinengzhijian',
    ZHI_NENG_DIAN_HUA_KE_FU: 'rengongzhineng-zhinengdianhuakefu',
    ZHI_NENG_WEN_ZI_KE_FU: 'rengongzhineng-zhinengwenzikefu',
    REN_GONG_KE_FU: 'rengongzhineng-rengongkefu',
    ZHI_NENG_WEN_BEN_SHEN_HE: 'rengongzhineng-zhinengwenbenshenhe'
  },
  QI_TA: {
    ZHI_NENG_BAN_GONG: {
      VANISH: 'qita-zhinengbangong-vanish',
      ZHI_BO_PING_TAI: 'qita-zhinengbangong-zhibopingtai',
      SHU_JU_DA_PING: 'qita-zhinengbangong-shujudaping'
    },
    QI_HUO: 'qita-qihuo',
    GANG_MEI_GU: 'qita-gangmeigu',
    GUO_MI_GAI_ZAO: 'qita-beidongxinggaizao-guomigaizao',
    XIN_CHUANG: 'qita-xinchuang',
    SHU_JU_KU: {
      I_FIND: 'qita-shujuku-ifind',
      ZI_XUN: 'qita-shujuku-zixun',
      YU_QING: 'qita-shujuku-yuqing',
      QI_YE_KU: 'qita-shujuku-qiyeku'
    }
  }
};